var _style, _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135.4 143.4",
    style: {
      enableBackground: "new 0 0 135.4 143.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000107586600285953537530000009665573675230796458_);}\n\t.st1{fill:#F28A19;}\n\t.st2{fill:none;stroke:#F28A19;stroke-width:4;stroke-linejoin:round;}\n\t.st3{fill:none;stroke:#F6A248;stroke-width:1.16;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0.4,
    width: 134.5,
    height: 142.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070829753217793974500000018087406277362399880_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070829753217793974500000018087406277362399880_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.1,28c0-1.1-0.6-1.9-1.6-2.2l-4.9-1.5l-2.9-0.9l-8.1-2.5l-10.6-3.2l-9.3-2.9L68.9,8.4 c-0.7-0.2-1.6-0.2-2.3,0c-2.6,0.8-5.2,1.6-7.8,2.4l-3,0.9l-2,0.6l-20,6.1l-1.2,0.4c-7.5,2.3-15,4.6-22.4,6.8 c-1.2,0.4-1.8,1.2-1.8,2.4v40.4c0,3.3,0,6.5,0.6,9.7c1,4.9,2.9,9.7,5.8,14.6c2.8,4.7,6.5,9.2,11.2,14c4.4,4.5,9.2,8.5,14.3,12.1 c4.6,3.3,8.9,6.1,13.1,8.7c2.9,1.8,5.9,3.3,8.8,4.9l4.1,2.2c0.9,0.5,1.9,0.5,2.8,0c5.6-2.7,11.1-5.8,16.4-9.2 c5.6-3.5,10.6-7.1,15.3-10.9c4.3-3.5,7.9-6.9,11.2-10.4c4-4.3,7.1-8.6,9.6-12.9c2.8-5,4.4-9.6,5-14c0.4-3,0.5-6.1,0.5-8.7 c0-8.4,0-16.9,0-25.3L127.1,28L127.1,28L127.1,28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.4,28c0-3.9-2.4-7.1-6.1-8.3l-4.9-1.5l-2.9-0.9l-8.1-2.5l-10.6-3.2l-9.3-2.9L70.7,2.4 c-1.9-0.6-4-0.6-6,0c-2.6,0.8-5.3,1.6-7.9,2.4l-3,0.9l-2,0.6l-20,6.1l-1.2,0.4c-7.5,2.3-14.9,4.6-22.4,6.8 C4.4,20.9,2,24.2,2,28.2v40.4c0,3.5,0,7.1,0.8,10.9C3.9,85.2,6,90.6,9.3,96.1c3.1,5.1,7,10.1,12.1,15.1c4.7,4.7,9.8,9,15.1,12.8 c4.7,3.4,9.2,6.3,13.5,8.9c3,1.8,6.1,3.4,9.2,5.1l4.1,2.2c2.7,1.5,5.8,1.5,8.6,0.1c5.8-2.9,11.5-6.1,17-9.5 c5.8-3.7,11-7.4,15.9-11.3c4.5-3.7,8.4-7.3,11.8-11c4.3-4.7,7.8-9.3,10.4-14.1c3.2-5.7,5.1-11,5.8-16.2c0.5-3.4,0.5-6.7,0.5-9.5 c0-8.4,0-16.9,0-25.3L133.4,28L133.4,28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127.1,28c0-1.1-0.6-1.9-1.6-2.2l-4.9-1.5l-2.9-0.9l-8.1-2.5l-10.6-3.2l-9.3-2.9L68.9,8.4 c-0.7-0.2-1.6-0.2-2.3,0c-2.6,0.8-5.2,1.6-7.8,2.4l-3,0.9l-2,0.6l-20,6.1l-1.2,0.4c-7.5,2.3-15,4.6-22.4,6.8 c-1.2,0.4-1.8,1.2-1.8,2.4v40.4c0,3.3,0,6.5,0.6,9.7c1,4.9,2.9,9.7,5.8,14.6c2.8,4.7,6.5,9.2,11.2,14c4.4,4.5,9.2,8.5,14.3,12.1 c4.6,3.3,8.9,6.1,13.1,8.7c2.9,1.8,5.9,3.3,8.8,4.9l4.1,2.2c0.9,0.5,1.9,0.5,2.8,0c5.6-2.7,11.1-5.8,16.4-9.2 c5.6-3.5,10.6-7.1,15.3-10.9c4.3-3.5,7.9-6.9,11.2-10.4c4-4.3,7.1-8.6,9.6-12.9c2.8-5,4.4-9.6,5-14c0.4-3,0.5-6.1,0.5-8.7 c0-8.4,0-16.9,0-25.3L127.1,28L127.1,28L127.1,28z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.8fc155d1b79422f11a2f6a47fc022380.svg";
export { ForwardRef as ReactComponent };